import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const ForgotPasswordPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h4">Forgot Password</Typography>
          <Typography>Forgot password page - Coming soon</Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ForgotPasswordPage;